// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popular{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    height: 90vh;
}
.popular h1{
    color: #171717;
    font-size: 50px;
    font-weight: 600;

}
.popular hr{
    width: 200px;
    height: 6px;
    border-radius: 10px;
    background: #252525;

}
.popular-item{
    margin-top: 50px;
    display: flex;
    gap: 30px;
}
@media(max-width:1280px){
    .popular{
        height: 70vh;
    }
    .popular h1{
        font-size: 40px;
    }
    .popular hr{
        width: 160px;
        height: 4px;
    }
    .popular-item{
        gap: 20px;
        margin-top: 30px;
    }

}
@media(max-width:1024px){
    .popular{
        height: 60vh;
    }
    .popular h1{
        font-size: 30px;
    }
    .popular hr{
        width: 120px;
        height: 3px;
    }
    .popular-item{
        gap: 15px;
        margin-top: 20px;
    }

}
@media(max-width:800px){
    .popular{
        height: 50vh;
        gap: 6px;
    }
    .popular h1{
        font-size: 20px;
    }
    .popular hr{
        width: 100px;
 
    }
    .popular-item{
        gap: 5px; 
    }

}
@media(max-width:500px){
    .popular{
        height: 90vh;
    }
    
    .popular-item{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px; 
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/Popular/Popular.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,YAAY;QACZ,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;;IAEhB;IACA;QACI,QAAQ;IACZ;;AAEJ;AACA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;AAEJ","sourcesContent":[".popular{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    height: 90vh;\n}\n.popular h1{\n    color: #171717;\n    font-size: 50px;\n    font-weight: 600;\n\n}\n.popular hr{\n    width: 200px;\n    height: 6px;\n    border-radius: 10px;\n    background: #252525;\n\n}\n.popular-item{\n    margin-top: 50px;\n    display: flex;\n    gap: 30px;\n}\n@media(max-width:1280px){\n    .popular{\n        height: 70vh;\n    }\n    .popular h1{\n        font-size: 40px;\n    }\n    .popular hr{\n        width: 160px;\n        height: 4px;\n    }\n    .popular-item{\n        gap: 20px;\n        margin-top: 30px;\n    }\n\n}\n@media(max-width:1024px){\n    .popular{\n        height: 60vh;\n    }\n    .popular h1{\n        font-size: 30px;\n    }\n    .popular hr{\n        width: 120px;\n        height: 3px;\n    }\n    .popular-item{\n        gap: 15px;\n        margin-top: 20px;\n    }\n\n}\n@media(max-width:800px){\n    .popular{\n        height: 50vh;\n        gap: 6px;\n    }\n    .popular h1{\n        font-size: 20px;\n    }\n    .popular hr{\n        width: 100px;\n \n    }\n    .popular-item{\n        gap: 5px; \n    }\n\n}\n@media(max-width:500px){\n    .popular{\n        height: 90vh;\n    }\n    \n    .popular-item{\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 20px; \n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
